<template>
  <div>
    <range-editor
      v-if="checkEditorType(replacerName, 'range')"
      :title="title"
      :replacer-name="replacerName"
      :current-value="getRangeValueByReplacerName(replacerName)"
      @updateValues="onUpdateParameterValues"
      @removeEditor="onRemoveEditor"
    />
    <switch-editor
      v-if="checkEditorType(replacerName, 'switch')"
      :title="title"
      :replacer-name="replacerName"
      :current-value="getSwitchValuesByReplacerName(replacerName)"
      @updateValues="onUpdateParameterValues"
      @removeEditor="onRemoveEditor"
    />
    <enum-editor
      v-if="checkEditorType(replacerName, 'enum')"
      :title="title"
      :replacer-name="replacerName"
      :available-values="getEnumAvailableValuesByReplacerName(replacerName)"
      :current-value="getEnumCurrentValueByReplacerName(replacerName)"
      :is-client-editable="getIsClientEditableByReplacerName(replacerName)"
      @updateValues="onUpdateParameterValues"
      @removeEditor="onRemoveEditor"
    />
  </div>
</template>

<script>
import RangeEditor from "./editors/RangeEditor";
import SwitchEditor from "./editors/SwitchEditor";
import EnumEditor from "./editors/EnumEditor";

export default {
  name: "ConfigEditor",
  components: { SwitchEditor, RangeEditor, EnumEditor },
  props: {
    replacerName: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    modelParameters: {
      type: Object,
      default: function() {},
    },
    availableConfigTemplates: {
      type: Object,
      default: function() {},
    },
    onUpdateParameterValues: {
      type: Function,
      default: function() {},
    },
    onRemoveEditor: {
      type: Function,
      default: function() {},
    },
  },
  data() {
    return {
      form: {
        available_config_templates: this.availableConfigTemplates,
        model_parameters: this.modelParameters,
      },
    };
  },
  methods: {
    refreshForm() {
      this.form = {
        available_config_templates: this.availableConfigTemplates,
        model_parameters: this.modelParameters,
      }
    },
    checkEditorType(replacerName, expectedType) {
      let isExpectedType = false;
      for (let i in this.form.available_config_templates) {
        if (
          this.form.available_config_templates[i].type === expectedType &&
          this.form.available_config_templates[i].replacer_name === replacerName
        ) {
          isExpectedType = true;
          break;
        }
      }
      return isExpectedType;
    },
    getRangeValueByReplacerName(replacerName) {
      let result = {
        value: null,
        isClientEditable: 1
      }
      for (let i in this.form.model_parameters) {
        if (this.form.model_parameters[i].replacer_name === replacerName) {
          result = {
            value: this.form.model_parameters[i].current_value * 1,
            min_value: this.form.model_parameters[i].available_values.min_value,
            max_value: this.form.model_parameters[i].available_values.max_value,
            step: this.form.model_parameters[i].available_values.step * 1,
            isClientEditable: this.form.model_parameters[i].is_client_editable
          };
          break;
        }
      }
      return result
    },
    getSwitchValuesByReplacerName(replacerName) {
      let result = {
        activeValue: null,
        disabledValue: null,
        currentValue: null,
        isClientEditable: 1
      }
      for (let i in this.form.model_parameters) {
        if (this.form.model_parameters[i].replacer_name === replacerName) {
          result = {
            activeValue: this.form.model_parameters[i].available_values.active_value,
            disabledValue: this.form.model_parameters[i].available_values.disabled_value,
            value: this.form.model_parameters[i].current_value,
            isClientEditable: this.form.model_parameters[i].is_client_editable,
          };
          break;
        }
      }
      return result
    },
    getEnumAvailableValuesByReplacerName(replacerName) {
      for (let i in this.form.model_parameters) {
        if (this.form.model_parameters[i].replacer_name === replacerName) {
          return this.form.model_parameters[i].available_values;
        }
      }
      return null;
    },
    getEnumCurrentValueByReplacerName(replacerName) {
      for (let i in this.form.model_parameters) {
        if (this.form.model_parameters[i].replacer_name === replacerName) {
          return {
            id: 0,
            text: this.form.model_parameters[i].default_text,
            value: this.form.model_parameters[i].current_value,
          };
        }
      }
    },
    getIsClientEditableByReplacerName(replacerName) {
      for (let i in this.form.model_parameters) {
        if (this.form.model_parameters[i].replacer_name === replacerName) {
          return this.form.model_parameters[i].is_client_editable
        }
      }
    },
  }
};
</script>

<style scoped>

</style>
